import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';
import { Brain, Stethoscope, Heart, Activity, Mail, Lock, X, Eye, EyeOff } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { encryptData } from '../../api/Services/encryptData';
import SignupForm from './SignupForm';
import ForgotPassword from './ForgotPassword';
// Import your signup form and other required components
// import SignupForm from './SignupForm';
// import logoimage from './path-to-logo';
// import login from './path-to-login-banner';
// import { EnglishText } from './path-to-english-text';

const EnhancedLoginModal = ({ visible, onHide, onSuccess }) => {
   
    const [mode, setMode] = useState("Login"); 
    const [loading, setLoading] = useState(false);
    const [looding, setLooding] = useState({
        isButtonLoading: false,
        isVersionLoading: false,
    });
    const [isSent, setSent] = useState(false);
    const [isOTPType, setType] = useState("");
    const [err, setErr] = useState("");
    const [showPass, setShowPass] = useState(false);
    const [hide, setHide] = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);
    const [timer, setTimer] = useState(60);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [flaginput, setFlaginput] = useState();
    const [signupforma, setSignupform] = useState(false);
    const [newpassword, setNewpassword] = useState(false);
    const [patientdata, setPatientdata] = useState("");
    const [signupno, setSignupno] = useState();
    const [proceedFlag, setProceedFlag] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [forgotModal, setForgotModal] = useState(false);

    const [user, setuser] = useState({
        userName: "",
        email: signupno || "",
        otp: "",
        password: "",
    });

    const [signUser, setsignUser] = useState({
        userName: "",
        email: "",
        otp: "",
        password: "",
        mobileNo: "",
    });

  
    useEffect(() => {
        let countdown;
        if (timer > 0) {
            countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else {
            setIsButtonDisabled(false);
        }
        return () => clearInterval(countdown);
    }, [timer]);

    // Reset login form whenever the modal opens so stale values (e.g. email
    // typed before navigating away via Forgot Password) don't persist.
    useEffect(() => {
        if (visible) {
            setMode("Login");
            setSignupform(false);
            setSent(false);
            setType("");
            setHide(false);
            setErr("");
            setuser({ userName: "", email: "", otp: "", password: "" });
            setsignUser({ userName: "", email: "", otp: "", password: "", mobileNo: "" });
            setProceedFlag(false);
        }
    }, [visible]);

  
    const handleValidations = () => {
        if (user.email.length === 0) {
            setErr("Please enter email or mobile number");
            return 0;
        }
        return 1;
    };

   
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "email") {
            setFlaginput(/^\d+$/.test(value));

            if (value.length === 0) {
                setErr("");
                setuser({ ...user, [name]: value });
                return;
            }

            if (/^\d/.test(value)) {
                const phoneDigits = value.replace(/\D/g, "");

                if (phoneDigits.length > 0 && !/^[6-9]/.test(phoneDigits)) {
                    setErr("Mobile number must start with 6, 7, 8, or 9");
                } else if (phoneDigits.length > 0 && phoneDigits.length !== 10) {
                    setErr("Please enter a 10-digit mobile number");
                } else if (phoneDigits.length === 10) {
                    setErr("");
                }
                setuser({ ...user, [name]: phoneDigits });
            } else {
                const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                if (!emailPattern.test(value)) {
                    setErr("Please enter a valid email address");
                } else if (value.length > 40) {
                    setErr("Input exceeds the maximum length of 40 characters");
                } else {
                    setErr("");
                }
                setuser({ ...user, [name]: value });
            }
        } else if (name === "otp") {
            const digits = value.replace(/\D/g, "").slice(0, 6);
            let errorMsg = "";
            if (digits.length > 0 && digits.length < 6) {
                errorMsg = "OTP must be exactly 6 digits";
            }
            setErr(errorMsg);
            setuser({ ...user, otp: digits });
        } else if (name === "password") {
            setuser({ ...user, password: value });
            if (!value.trim()) {
                setErr("Password cannot be empty");
            } else {
                setErr("");
            }
        } else {
            setuser({ ...user, [name]: value });
        }
    };

  
    const handleChange1 = (e) => {
        const { name, value } = e.target;
        let inputValue = value.replace(/\D/g, "").slice(0, 10);

        if (name === "email") {
            setFlaginput(true);

            if (inputValue.length > 0 && !/^[6-9]/.test(inputValue)) {
                setErr("Mobile number must start with 6, 7, 8, or 9");
            } else if (inputValue.length === 10) {
                const regx = /^[6-9]\d{9}$/;
                if (!regx.test(inputValue)) {
                    setErr("Invalid mobile number format");
                } else {
                    setErr("");
                }
            } else if (inputValue.length === 0) {
                setErr("");
            } else {
                setErr("");
            }
        }
        setuser({ ...user, [name]: inputValue });
    };

   
    const sendOTPAPI = async (data) => {
        const response = await fetch(
            `${process.env.REACT_APP_BASEURL}patient-user/initiate`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ...data, sourceChannel: "D2C_QUANTUM" }),
            }
        );
        return await response.json();
    };

    const verifyOTPAPI = async (data) => {
        const token = sessionStorage.getItem("token");
        const headers = {
            "Content-Type": "application/json",
        };

        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }

        const response = await fetch(
            `${process.env.REACT_APP_BASEURL}patient-user/authentication/validate/otp`,
            {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            }
        );
        return await response.json();
    };

    const loginWithPasswordAPI = async (data) => {
        const token = sessionStorage.getItem("token");
        const headers = {
            "Content-Type": "application/json",
        };

        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        const response = await fetch(
            `${process.env.REACT_APP_BASEURL}patient-user/authentication/login/email`,
            {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            }
        );
        return await response.json();
    };

    // Modal close functions
    const modalClose = () => {
        handleClose();
    };

    const loginfalse = () => {
        setMode("Login");
        setSignupform(false);
    };

    const setIsModalOpenLogin = (value) => {
        if (!value) {
            handleClose();
        }
    };

  
    const sendOTPMobile = async (e, flag) => {
      
        e.preventDefault();
        setErr("");

        if (!handleValidations()) return;

        setLooding({ isButtonLoading: true });

        try {
            let result;
            if (flaginput) {
                const dataObj = { mobileNumber: user.email || signUser.mobileNo };
                result = await sendOTPAPI(dataObj);
            } else {
                // For email OTP, use direct fetch as in original
                const payload = { email: user.email };
                const response = await fetch(
                    `${process.env.REACT_APP_BASEURL}patient-user/authentication/email/otp`,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload),
                    }
                );
                result = await response.json();
            }

            const isRegistered = result?.data?.isUserRegistered;

            if (isRegistered === "Y" || isRegistered === "N") {
                setSent(true);
                setHide(true);
                setErr("");
                setTimer(60);
                setIsButtonDisabled(true);
            } else {
                setErr(result?.message || "User registration status unknown.");
            }
        } catch (error) {
            console.error("OTP Error:", error);
            const msg = error?.response?.data?.details?.[0] || error?.message || "Something went wrong";
            setErr(msg);
        } finally {
            setLooding({ isButtonLoading: false });
        }
    };

    // Verify OTP function
    const onVerifyingOtp = async (e) => {
        e.preventDefault();

        if (!handleValidations()) return;

        let data = {};
        if (flaginput) {
            data = {
                mobileNumber: user.email,
                otp: parseInt(user.otp),
            };
        } else {
            data = {
                email: user.email,
                otp: parseInt(user.otp),
            };
        }

        setLooding({ isButtonLoading: true });

        try {
            const result = await verifyOTPAPI(data);
            console.log(result,result?.data?.isUserRegistered,"responsesignup")
            if (result?.data) {
                if (result?.data?.isUserRegistered === "N") {
                    setSignupform(true);
                    setSent(false);
                } else if (proceedFlag === true) {
                    setNewpassword(true);
                    setProceedFlag(false);
                    setPatientdata(result?.data?.patientCode);
                } else if (result?.data?.isUserRegistered === "Y") {
                    const modifiedData = {
                        ...result?.data,
                        patientId: result?.data?.patientCode,
                        firstname: result?.data?.firstName,
                        lastname: result?.data?.lastName,
                        firstName: result?.data?.firstName,
                        lastName: result?.data?.lastName,
                        email: result?.data?.email || user.email,
                        mobile: result?.data?.mobileNumber || user.email,
                        code: result?.data?.patientCode,
                        sessionid: result?.data?.sessionId
                    };

                    delete modifiedData.patientCode;
                    delete modifiedData.firstName;
                    delete modifiedData.lastName;
                     delete modifiedData.mobileNumber;

                    // WebEngage tracking (if available)
                    if (window.webengage && window.webengage.user) {
                        window.webengage.user.login(modifiedData.code);
                        window.webengage.user.setAttribute('we_email', modifiedData.email);
                        window.webengage.user.setAttribute('we_mobile', modifiedData.mobileNumber);
                        window.webengage.user.setAttribute('we_name', modifiedData.firstName + ' ' + modifiedData.lastName);
                    }

                    // Store authentication data
                    localStorage.setItem("loginstatus", result?.status);
                    localStorage.setItem("token", result?.data?.authToken);
                    localStorage.setItem("loginObj", JSON.stringify(modifiedData));
                    console.log(JSON.stringify(modifiedData), "logindta")

                    // IMPORTANT: Trigger a custom event to notify hooks about login
                    window.dispatchEvent(new CustomEvent('loginComplete', { 
                        detail: { loginData: modifiedData } 
                    }));

                    if (onSuccess) onSuccess(modifiedData);
                    handleClose();
                }
            }
        } catch (error) {
            const msg = error?.response?.data?.details?.[0] || "Something went wrong. Please try again.";
            setErr(msg);
        } finally {
            setLooding({ isButtonLoading: false });
        }
    };
console.log(signupforma,"rdtfgyhuhuj")
    // Login with password function
    const LoginWithPassword = async (e) => {
        if ((e?.key !== "Enter" && e?.type === "keydown") || !user.password.length) {
            return;
        }

        const payload = {
            email: user.email,
            password: user.password,
        };

        setLooding({ isButtonLoading: true });

        try {
            const result = await loginWithPasswordAPI(encryptData(payload));
            
            if (result.data && result.data.success === false) {
                setErr(result.data.message);
                return;
            }

            const { data } = result;
            const modified = {
                ...data,
                patientId: data.patientCode,
                code: data.patientCode,
                firstname: data?.firstName,
                lastname: data?.lastName,
                mobile:data?.mobileNumber,

            };
            
            delete modified.patientCode;
            delete modified.firstName;
            delete modified.lastName;
            delete modified?.mobileNumber;
            
            console.log(JSON.stringify(modified), "logindta");
            
            // Store authentication data
            localStorage.setItem("token", data.authToken);
            localStorage.setItem("loginstatus", "true");
            localStorage.setItem("loginObj", JSON.stringify(modified));

            // IMPORTANT: Trigger a custom event to notify hooks about login
            window.dispatchEvent(new CustomEvent('loginComplete', { 
                detail: { loginData: modified } 
            }));

            if (onSuccess) onSuccess(modified);
            handleClose();
            
        } catch (error) {
            console.error("LOGIN ERROR", error);
            const msg = error.response?.data?.message || "Something went wrong. Please try again.";
            setErr(msg);
        } finally {
            setLooding({ isButtonLoading: false });
        }
    };

    // Password validation and login type toggle
    const loginValidation = async () => {
        if (!user?.email || user.email.trim().length === 0) {
            setErr("Please enter email");
            return;
        }

        const re = /\S+@\S+\.\S+/;
        if (!re.test(user.email)) {
            setErr("Please enter a valid email");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_BASEURL}patient-user/check-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email: user.email }),
            });

            const data = await response.json();

            if (!response.ok) {
                if (data?.message === "User Password Not Present!") {
                    setProceedFlag(true);
                }
                setErr(data?.message || "An error occurred");
            } else {
                setType(isOTPType === "" ? "password" : "");
                setErr("");
            }
        } catch (error) {
            console.error("API error:", error);
            setErr("Something went wrong. Please try again later.");
        }
    };

    const handleClose = () => {
        setMode("Login");
        setSignupform(false);
        setSent(false);
        setType("");
        setHide(false);
        setErr("");
        setuser({
            userName: "",
            email: "",
            otp: "",
            password: "",
        });
        setsignUser({
            userName: "",
            email: "",
            otp: "",
            password: "",
            mobileNo: "",
        });
        setProceedFlag(false);
        if (onHide) onHide();
    };

    const showForgotModal = () => {
        setMode('ForgotPwd');
        setForgotModal(true);
    };

    const forgotModalClose = () => {
        setForgotModal(false);
        setMode('Login');
    };

    const handleLoginClick = () => {
        setForgotModal(false);
        setMode('Login');
    };

    // Validation helpers
    const isInputEmpty = user.email.trim().length === 0;
    const hasError = err.length > 0;
    const shouldDisable = isInputEmpty || hasError;

    const FloatingIcon = ({ Icon, className, delay }) => (
        <motion.div
            initial={{ y: 0, opacity: 0.08 }}
            animate={{ y: [0, -10, 0], opacity: 0.12 }}
            transition={{ duration: 6, repeat: Infinity, delay }}
            className={`absolute text-blue-300 ${className}`}
        >
            <Icon size={22} />
        </motion.div>
    );

    const modalHeader = () => (
        <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-3">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-r from-[#004276] to-[#004276] rounded-xl shadow-xl">
                    <Brain className="text-white" size={24} />
                </div>
                <div>
                    <h2 className="text-xl font-bold bg-gradient-to-r from-[#004276] to-[#004276] bg-clip-text text-transparent">
                        {mode === "Login" ? "Welcome Back" : "Reset Password"}
                    </h2>
                    <p className="text-gray-500 text-xs">Intelligent Healthcare Solutions</p>
                </div>
            </div>
        </div>
    );

    const renderLoginForm = () => (
        <div className="space-y-5">
            {isSent ? (
                // OTP Input
                <div className="space-y-4">
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                            <Lock size={14} className="text-blue-500" /> Enter OTP
                        </label>
                        <InputText
                            name="otp"
                            value={user.otp}
                            onChange={handleChange}
                            placeholder="Enter 6-digit OTP"
                            className="w-full pl-4 pr-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white/70 hover:bg-white/90"
                            maxLength={6}
                        />
                    </div>
                    {err && <p className="text-red-500 text-xs">{err}</p>}

                    <Button
                        type="button"
                        label={looding.isButtonLoading ? 'Verifying...' : 'Verify OTP'}
                        loading={looding.isButtonLoading}
                        className="w-full py-2.5 bg-gradient-to-r from-[#004276] to-[#004276] hover:from-[#003360] hover:to-[#003360] border-0 rounded-lg font-medium text-white shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all"
                        onClick={onVerifyingOtp}
                        disabled={user.otp.length !== 6 || Boolean(err)}
                    />

                    <div className="text-center">
                        <button
                            onClick={sendOTPMobile}
                            disabled={isButtonDisabled}
                            className="text-blue-600 hover:text-blue-800 text-sm transition-colors disabled:text-gray-400"
                        >
                            Resend OTP {isButtonDisabled && `in ${timer} sec`}
                        </button>
                    </div>
                </div>
            ) : isOTPType === "password" ? (
                // Password Input
                <div className="space-y-4">
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                            <Lock size={14} className="text-blue-500" /> Password
                        </label>
                        <div className="relative">
                            <input
                                type={passwordShown ? "text" : "password"}
                                name="password"
                                value={user.password}
                                onChange={handleChange}
                                placeholder="Enter your password"
                                className="w-full pl-4 pr-12 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white/70 hover:bg-white/90"
                            />
                            <button
                                type="button"
                                onClick={() => setPasswordShown(!passwordShown)}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                            >
                                {passwordShown ? <EyeOff size={16} /> : <Eye size={16} />}
                            </button>
                        </div>
                    </div>

                    <div className="text-right">
                        <button
                            onClick={showForgotModal}
                            className="text-blue-600 hover:text-blue-800 text-sm transition-colors"
                        >
                            Forgot Password?
                        </button>
                    </div>

                    {err && <p className="text-red-500 text-xs">{err}</p>}

                    <Button
                        type="button"
                        label={looding.isButtonLoading ? 'Logging in...' : 'Login'}
                        loading={looding.isButtonLoading}
                        className="w-full py-2.5 bg-gradient-to-r from-[#004276] to-[#004276] hover:from-[#003360] hover:to-[#003360] border-0 rounded-lg font-medium text-white shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all"
                        onClick={LoginWithPassword}
                        disabled={!user.password.trim()}
                    />

                    <div className="text-center">
                        <button
                            onClick={() => setType("")}
                            className="text-blue-600 hover:text-blue-800 text-sm underline transition-colors"
                        >
                            Login with OTP
                        </button>
                    </div>
                </div>
            ) : (
                // Email/Mobile Input
                <div className="space-y-4">
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
                            <Mail size={14} className="text-blue-500" /> Email or Mobile
                        </label>
                        <input
                            type="text"
                            name="email"
                            value={user.email}
                            onChange={handleChange}
                            placeholder="Enter email or mobile number"
                            className="w-full pl-4 pr-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white/70 hover:bg-white/90"
                            maxLength={40}
                        />
                    </div>

                    {err && <p className="text-red-500 text-xs">{err}</p>}

                    {proceedFlag && (
                        <div className="text-sm text-gray-600">
                            Please <button
                                className="text-blue-600 underline"
                                onClick={(e) => {
                                    setSent(true);
                                    sendOTPMobile(e);
                                    setErr("");
                                }}
                            >
                                Proceed
                            </button> to set the password
                        </div>
                    )}

                    {flaginput === false && (
                        <div className="text-right">
                            <button
                                onClick={loginValidation}
                                className="text-blue-600 hover:text-blue-800 text-sm underline transition-colors"
                            >
                                Use Password
                            </button>
                        </div>
                    )}

                    <Button
                        type="button"
                        label={looding.isButtonLoading ? 'Sending...' : 'Send OTP'}
                        loading={looding.isButtonLoading}
                        className="w-full py-2.5 bg-gradient-to-r from-[#004276] to-[#004276] hover:from-[#003360] hover:to-[#003360] border-0 rounded-lg font-medium text-white shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all"
                        onClick={sendOTPMobile}
                        disabled={shouldDisable}
                    />
                </div>
            )}
        </div>
    );

    

   const renderSignupForm = () => (
        <div className="space-y-5">
            <div className="text-center mb-4">
                {/* <img src={logoimage} alt="images" className="w-[140px] mx-auto mb-4" /> */}
                <div className="text-sm text-gray-600">
                    Hassle-free healthcare delivered
                </div>
            </div>
            
            <SignupForm
                modalClose={modalClose}
                loginfalse={loginfalse}
                mobile={signUser?.mobileNo || user?.email}
                setMode={setMode}
                setSignupform={setSignupform}
                setSignupno={setSignupno}
                setIsModalOpenLogin={setIsModalOpenLogin}
            />
        </div>
    );

    return (
        <AnimatePresence>
            {visible && (
                <Dialog
                    visible={visible}
                    onHide={onHide}
                    header={modalHeader}
                    modal
                    // className="login-modal w-full max-w-md mx-4"
                    contentClassName="p-0"
                    headerClassName="border-b-0 pb-4"
                   
                    draggable={false}
                    resizable={false}
                    style={{
                        borderRadius: '1rem',
                        overflow: 'hidden',
                        background: 'rgba(255, 255, 255, 0.9)',
                        backdropFilter: 'blur(24px)',
                        border: '1px solid rgba(255, 255, 255, 0.25)',
                        boxShadow: '0 30px 60px -15px rgba(0, 0, 0, 0.35)'
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 40 }}
                        transition={{ duration: 0.4, ease: 'easeOut' }}
                        className="relative overflow-hidden"
                    >
                        {/* Background elements */}
                        <div className="absolute inset-0 overflow-hidden pointer-events-none">
                            <FloatingIcon Icon={Brain} className="top-6 left-6" delay={0} />
                            <FloatingIcon Icon={Heart} className="top-10 right-10" delay={1} />
                            <FloatingIcon Icon={Activity} className="bottom-10 left-8" delay={2} />
                            <FloatingIcon Icon={Stethoscope} className="bottom-6 right-6" delay={1.5} />
                            <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-r from-blue-200 to-[#DFF1FB] rounded-full opacity-10 blur-3xl"></div>
                            <div className="absolute bottom-0 right-0 w-28 h-28 bg-gradient-to-r from-[#DFF1FB] to-pink-200 rounded-full opacity-10 blur-3xl"></div>
                        </div>

                        {/* Content */}
                        <div className="p-6 pt-4 relative z-10">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.1 }}
                            >
                               {signupforma ? renderSignupForm() : renderLoginForm()}

                                {/* Footer */}
                                <div className="text-center mt-4 pt-4 border-t border-gray-100">
                                    <p className="text-xs text-gray-500 leading-relaxed">
                                        By continuing, you agree to our{' '}
                                        <button className="text-blue-600 hover:underline">Terms</button> and{' '}
                                        <button className="text-blue-600 hover:underline">Privacy Policy</button>
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                    </motion.div>
                </Dialog>
            )}

            {mode === "ForgotPwd" && (
                <Dialog
                    visible={forgotModal}
                    onHide={forgotModalClose}
                    header={
                        <p className=" text-[#004171] ">
                            Forgot Password
                        </p>
                    }
                    modal
                  
                    // contentClassName="p-0"
                    // headerClassName="border-b-0 pb-4"
                    draggable={false}
                    resizable={false}
                    className="loginmodal"
                >
                    <ForgotPassword
                        forgotModal={forgotModal}
                        handleLoginClick={handleLoginClick}
                        setForgotModal={setForgotModal}
                        showForgotModal={showForgotModal}
                        forgotModalClose={forgotModalClose}
                    />
                </Dialog>
            )}
        </AnimatePresence>
    );
};

const LoginModal = ({ visible, onHide, onSuccess }) => {
    const [showModal, setShowModal] = useState(false);
    const [user, setUser] = useState(null);

    const handleSuccess = (userData) => {
        setUser(userData);
        console.log('Login successful:', userData);
    };

    return (
        <>
            {user ? (
                <></>
            ) : (
                <EnhancedLoginModal
                    visible={visible}
                    onHide={onHide}
                    onSuccess={onSuccess}
                />
            )}
        </>
    );
};

export default LoginModal;